import { CoreContext } from "bundles/core/CoreContext";
import React from "react";
import { Link } from "react-router-dom";

// Context-aware link component
//
// This component will render a react-router pushState link if the following
// conditions are met:
//
// 1. A `to` prop is provided
// 2. The current entry bundle into the app is `core`
//
// Otherwise, a standard anchor tag will be rendered

export const CoreLink = React.forwardRef((props, ref) => {
  const { to, href, ...rest } = props;
  return (
    <CoreContext.Consumer>
      {(isCore) =>
        isCore && to ? <Link innerRef={ref} to={to} {...rest} /> : <a ref={ref} href={href || to} {...rest} />
      }
    </CoreContext.Consumer>
  );
});
